import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import Logo from "../assets/logo.jpg";
// import Sitemap from "./components/FooterPages/SiteMap/Sitemap";


function Footer() {
  return (
    <footer className="footer" role="contentinfo">
      <div className="footer-container">

        {/* LOGO + BRAND INFO */}
        <div className="footer-section">
          <Link to="/" aria-label="LushDesire Home">
            <img
              src={Logo}
              alt="LushDesire – Buy Sex Toys Online in India"
              className="footer-logo"
              loading="lazy"
            />
          </Link>

          <p className="footer-text">
            <strong>LushDesire</strong> is India’s trusted online adult store
            offering premium sex toys for men, women & couples with
            <strong> 100% discreet delivery</strong> across India.
          </p>
        </div>

        {/* QUICK LINKS */}
        <nav className="footer-section" aria-label="Footer Quick Links">
          <h3>Shop Sex Toys Online</h3>
          <ul>
            <li>
              <Link to="/women"><h1>Sex Toys for Women</h1></Link>
            </li>
            <li>
              <Link to="/men"><h1>Sex Toys for Men</h1></Link>
            </li>
            <li>
              <Link to="/couples"><h1>BDSM Toys Online India</h1></Link>
            </li>
            <li>
              <Link to="/women"><h1>Anal Toys Online India</h1></Link>
            </li>
            <li>
              <Link to="/men"><h1>Adult Toys Online India</h1></Link>
            </li>
          </ul>
        </nav>

        {/* ABOUT COMPANY */}
        <nav className="footer-section" aria-label="About LushDesire">
          <h3>About LushDesire</h3>
          <ul>
            <li>
              <Link to="/about"><h1>About LushDesire India</h1></Link>
            </li>
            <li>
              <Link to="/men"><h1>Sex Toys for Men in India</h1></Link>
            </li>
            <li>
              <Link to="/men"><h1>Buy Sex Toys Online in India</h1></Link>
            </li>
            <li>
              <Link to="/contact"><h1>Contact LushDesire</h1></Link>
            </li>
            <li>
              <Link to="/blog"><h1>Sex Toys Blog India</h1></Link>
            </li>
          </ul>
        </nav>

        {/* POLICIES */}
        <nav className="footer-section" aria-label="Legal Policies">
          <h3>Customer Policies</h3>
          <ul>
            <li>
              <Link to="/privacy-policy"><h1>Privacy Policy</h1></Link>
            </li>
            <li>
              <Link to="/terms-conditions"><h1>Terms & Conditions</h1></Link>
            </li>
            <li>
              <Link to="/refund-policy"><h1>Refund Policy</h1></Link>
            </li>
            <li>
              <Link to="/discreet-delivery"><h1>Discreet Delivery in India</h1></Link>
            </li>
          </ul>
        </nav>

        {/* DELIVERY CITIES – STATE WISE (SEO BOOST) */}
{/* DELIVERY CITIES – STATE WISE (SEO POWER) */}
{/* DELIVERY CITIES – STATE WISE (MEGA SEO) */}
<div className="footer-section footer-cities">
  <h3>Sex Toys Delivery Across India</h3>

  {/* GUJARAT */}
  <details open>
    <summary>📍 Sex Toys Delivery in Gujarat</summary>
    <p>
      <Link to="/sex-toys-delivery/gujarat/ahmedabad">Sex Toys in Ahmedabad</Link> |{" "}
      <Link to="/sex-toys-delivery/gujarat/surat">Sex Toys in Surat</Link> |{" "}
      <Link to="/sex-toys-delivery/gujarat/vadodara">Sex Toys in Vadodara</Link> |{" "}
      <Link to="/sex-toys-delivery/gujarat/rajkot">Sex Toys in Rajkot</Link> |{" "}
      <Link to="/sex-toys-delivery/gujarat/gandhinagar">Sex Toys in Gandhinagar</Link>
    </p>
  </details>

  {/* MAHARASHTRA */}
  <details>
    <summary>📍 Sex Toys Delivery in Maharashtra</summary>
    <p>
      <Link to="/sex-toys-delivery/maharashtra/mumbai">Sex Toys in Mumbai</Link> |{" "}
      <Link to="/sex-toys-delivery/maharashtra/pune">Sex Toys in Pune</Link> |{" "}
      <Link to="/sex-toys-delivery/maharashtra/nagpur">Sex Toys in Nagpur</Link> |{" "}
      <Link to="/sex-toys-delivery/maharashtra/thane">Sex Toys in Thane</Link> |{" "}
      <Link to="/sex-toys-delivery/maharashtra/nashik">Sex Toys in Nashik</Link>
    </p>
  </details>

  {/* DELHI NCR */}
  <details>
    <summary>📍 Sex Toys Delivery in Delhi NCR</summary>
    <p>
      <Link to="/sex-toys-delivery/delhi-ncr/delhi">Sex Toys in Delhi</Link> |{" "}
      <Link to="/sex-toys-delivery/delhi-ncr/noida">Sex Toys in Noida</Link> |{" "}
      <Link to="/sex-toys-delivery/delhi-ncr/gurugram">Sex Toys in Gurugram</Link> |{" "}
      <Link to="/sex-toys-delivery/delhi-ncr/faridabad">Sex Toys in Faridabad</Link> |{" "}
      <Link to="/sex-toys-delivery/delhi-ncr/ghaziabad">Sex Toys in Ghaziabad</Link>
    </p>
  </details>

  {/* KARNATAKA */}
  <details>
    <summary>📍 Sex Toys Delivery in Karnataka</summary>
    <p>
      <Link to="/sex-toys-delivery/karnataka/bangalore">Sex Toys in Bengaluru</Link> |{" "}
      <Link to="/sex-toys-delivery/karnataka/mysuru">Sex Toys in Mysuru</Link> |{" "}
      <Link to="/sex-toys-delivery/karnataka/mangalore">Sex Toys in Mangaluru</Link> |{" "}
      <Link to="/sex-toys-delivery/karnataka/hubli">Sex Toys in Hubli</Link> |{" "}
      <Link to="/sex-toys-delivery/karnataka/belgaum">Sex Toys in Belgaum</Link>
    </p>
  </details>

  {/* TAMIL NADU */}
  <details>
    <summary>📍 Sex Toys Delivery in Tamil Nadu</summary>
    <p>
      <Link to="/sex-toys-delivery/tamil-nadu/chennai">Sex Toys in Chennai</Link> |{" "}
      <Link to="/sex-toys-delivery/tamil-nadu/coimbatore">Sex Toys in Coimbatore</Link> |{" "}
      <Link to="/sex-toys-delivery/tamil-nadu/madurai">Sex Toys in Madurai</Link> |{" "}
      <Link to="/sex-toys-delivery/tamil-nadu/trichy">Sex Toys in Trichy</Link> |{" "}
      <Link to="/sex-toys-delivery/tamil-nadu/salem">Sex Toys in Salem</Link>
    </p>
  </details>

  {/* TELANGANA */}
  <details>
    <summary>📍 Sex Toys Delivery in Telangana</summary>
    <p>
      <Link to="/sex-toys-delivery/telangana/hyderabad">Sex Toys in Hyderabad</Link> |{" "}
      <Link to="/sex-toys-delivery/telangana/secunderabad">Sex Toys in Secunderabad</Link> |{" "}
      <Link to="/sex-toys-delivery/telangana/warangal">Sex Toys in Warangal</Link> |{" "}
      <Link to="/sex-toys-delivery/telangana/karimnagar">Sex Toys in Karimnagar</Link> |{" "}
      <Link to="/sex-toys-delivery/telangana/nizamabad">Sex Toys in Nizamabad</Link>
    </p>
  </details>

  {/* UTTAR PRADESH */}
  <details>
    <summary>📍 Sex Toys Delivery in Uttar Pradesh</summary>
    <p>
      <Link to="/sex-toys-delivery/uttar-pradesh/lucknow">Sex Toys in Lucknow</Link> |{" "}
      <Link to="/sex-toys-delivery/uttar-pradesh/noida">Sex Toys in Noida</Link> |{" "}
      <Link to="/sex-toys-delivery/uttar-pradesh/ghaziabad">Sex Toys in Ghaziabad</Link> |{" "}
      <Link to="/sex-toys-delivery/uttar-pradesh/kanpur">Sex Toys in Kanpur</Link> |{" "}
      <Link to="/sex-toys-delivery/uttar-pradesh/agra">Sex Toys in Agra</Link>
    </p>
  </details>

  {/* RAJASTHAN */}
  <details>
    <summary>📍 Sex Toys Delivery in Rajasthan</summary>
    <p>
      <Link to="/sex-toys-delivery/rajasthan/jaipur">Sex Toys in Jaipur</Link> |{" "}
      <Link to="/sex-toys-delivery/rajasthan/jodhpur">Sex Toys in Jodhpur</Link> |{" "}
      <Link to="/sex-toys-delivery/rajasthan/udaipur">Sex Toys in Udaipur</Link> |{" "}
      <Link to="/sex-toys-delivery/rajasthan/kota">Sex Toys in Kota</Link> |{" "}
      <Link to="/sex-toys-delivery/rajasthan/ajmer">Sex Toys in Ajmer</Link>
    </p>
  </details>

  {/* WEST BENGAL */}
  <details>
    <summary>📍 Sex Toys Delivery in West Bengal</summary>
    <p>
      <Link to="/sex-toys-delivery/west-bengal/kolkata">Sex Toys in Kolkata</Link> |{" "}
      <Link to="/sex-toys-delivery/west-bengal/howrah">Sex Toys in Howrah</Link> |{" "}
      <Link to="/sex-toys-delivery/west-bengal/durgapur">Sex Toys in Durgapur</Link> |{" "}
      <Link to="/sex-toys-delivery/west-bengal/siliguri">Sex Toys in Siliguri</Link> |{" "}
      <Link to="/sex-toys-delivery/west-bengal/asansol">Sex Toys in Asansol</Link>
    </p>
  </details>

  {/* MADHYA PRADESH */}
  <details>
    <summary>📍 Sex Toys Delivery in Madhya Pradesh</summary>
    <p>
      <Link to="/sex-toys-delivery/madhya-pradesh/indore">Sex Toys in Indore</Link> |{" "}
      <Link to="/sex-toys-delivery/madhya-pradesh/bhopal">Sex Toys in Bhopal</Link> |{" "}
      <Link to="/sex-toys-delivery/madhya-pradesh/gwalior">Sex Toys in Gwalior</Link> |{" "}
      <Link to="/sex-toys-delivery/madhya-pradesh/jabalpur">Sex Toys in Jabalpur</Link> |{" "}
      <Link to="/sex-toys-delivery/madhya-pradesh/ujjain">Sex Toys in Ujjain</Link>
    </p>
  </details>
</div>





      </div>

      {/* COPYRIGHT */}
      <div className="footer-bottom">
  © {new Date().getFullYear()} <strong>LushDesire.in</strong> – Buy Sex Toys
  Online in India with Privacy & Trust.

  <span style={{ marginLeft: "10px" }}>
    |{" "}
    <Link
      to="/sitemap"
      style={{ color: "#fff", textDecoration: "underline" }}
    >
      Sitemap
    </Link>
  </span>
</div>

    </footer>
  );
}

export default Footer;
